import React, { useEffect, useState } from "react";
import "./expensesStyle.css";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { useNavigate } from "react-router-dom";
import { BiEditAlt } from "react-icons/bi";
import ExpenseFilter from "./expense_filter/ExpenseFilter";
import CustomBottomPagination from "../../../../components/custom_bottom_pagination/CustomBottomPagination";
import { LocalStorageServices } from "../../../../services/localStorageServices";

function Expenses() {
  const navigate = useNavigate();
  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/master_settings`
  const [expensesList, setExpensesList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItemPerPage, setTotalItemPerPage] = useState(10);

  useEffect(() => {
    getExpenses();
  }, [pageNumber, totalItemPerPage]);

  const getExpenses = () => {
    // Dummy data for now
    const dummyData = [
      {key:1, id: 1, name: "Travel", status: "Active" },
      {key:2,  id: 2, name: "Stationery", status: "Inactive" },
      {key:3, id: 3, name: "Maintenance", status: "Active" },
    ];
    setExpensesList(dummyData);
  };

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",

    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      wrapper: (row) => (
        <div >
          <p style={{ color: row.status == 'Active' ? '#0A9E02' : "#FF0000" }}>{row.status}</p>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div style={{ display: "flex",justifyContent:'center', alignItems: "center" }}>
          <BiEditAlt
            className="locations_action_edit"
            onClick={() => navigate(baseRouteUrl + `/${row.id}/update_expense_head`)}
          />
        </div>
      ),
    },
  ];

  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount);
  };

  return (
    <div className="locations_module_main_container">
      <p className="locations_title">Expenses Head</p>

      <div className="locations_module_filter">
        <ExpenseFilter/>
        <button
          className="locations_add_button"
          onClick={() => navigate(baseRouteUrl + `/create_new_expense_head`)}
        >
          Add New
        </button>
      </div>

      <div className="locations_table_main_container">
        <CustomTable
          columns={Columns}
          rows={expensesList}
        />
      </div>
       <div>
        <CustomBottomPagination total_items_per_page={10} total_page_count={1} current_page={pageNumber} on_change_value={updatePagination} on_page_count_update={updateItemPageCount} />
      </div>
    </div>
  );
}

export default Expenses;
